export default {
  "content": "<g clip-path=\"url(#clip0_431_53577)\" fill=\"#fff\"><path d=\"M2.438 6.501a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM8.125 6.5a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM10.563 8.125H5.686a2.437 2.437 0 00-2.437 2.438v2.254a.183.183 0 00.183.183h9.384a.183.183 0 00.183-.183v-2.255a2.438 2.438 0 00-2.438-2.437z\"/><path d=\"M4.497 7.546a.975.975 0 00-.617-.234H.995A.994.994 0 000 8.309v2.918a.15.15 0 00.15.149h2.287v-.813a3.25 3.25 0 012.06-3.016z\"/></g><defs><clipPath id=\"clip0_431_53577\"><path fill=\"#fff\" d=\"M0 0h13v13H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};